import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useActions } from '../../../../../hooks/useActions';
import { SecondaryButton } from '../../../../../components/SecondaryButton/SecondaryButton';
var options = {
    shadow: [
        { label: 'None', value: 'none' },
        { label: 'Drop', value: 'dropped' },
        { label: 'Lift', value: 'raised' },
        { label: 'Outline', value: 'outlined' },
    ],
    size: [
        { label: 'Small', value: 0 },
        { label: 'Default', value: 1 },
        { label: 'Large', value: 2 },
    ],
};
export var SettingsButtons = function (_a) {
    var mode = _a.mode, type = _a.type, themeValue = _a.themeValue, setting = _a.setting, _b = _a.isDisable, isDisable = _b === void 0 ? false : _b, children = _a.children;
    var _c = useActions(), setTextShadow = _c.setTextShadow, setTextSize = _c.setTextSize, setCommonMatrixProperty = _c.setCommonMatrixProperty;
    var onClick = function (value) {
        if (type) {
            setCommonMatrixProperty({ type: type, value: value });
            return;
        }
        if (setting === 'shadow') {
            setTextShadow({ mode: mode, value: value });
        }
        if (setting === 'size') {
            setTextSize({ mode: mode, value: value });
        }
    };
    return (_jsxs(_Fragment, { children: [options[setting].map(function (item) { return (_jsx(SecondaryButton, { title: item.label, handleClick: function () { return onClick(item.value); }, isBordered: false, isActive: item.value === themeValue, isDisabled: isDisable, fontSize: '14px', style: {
                    paddingTop: '0',
                    paddingBottom: '0',
                    height: '24px',
                } }, item.value)); }), children] }));
};
